/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-as-const */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Button, Divider, IconButton, MobileStepper, Paper, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import Snackbar from '@mui/material/Snackbar';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AddUserModalProps } from './addUserModalTypes';
import AddUserForm from './AddUserForm';
import AddUserGroups from './AddUserGroups';
import { useTypedDispatch } from '../../../redux/dispatchActionTypes/dispatchAndThunkActionTypes';
import { useSelector } from 'react-redux';
import { addUser, fetchUserGroups } from '../../../redux/actions/accountUsersActions';
import { AccountUsersProps } from '../AccountUsersTypes';
import { useTranslation, Trans } from 'react-i18next';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    backgroundColor: 'background.paper',
    boxShadow: 20,
    p: 0,
};

export default function AddUserModal({ count, setCount, open, setOpen }: AddUserModalProps): JSX.Element {
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.down('md'));
    const dispatch = useTypedDispatch();
    const { currentUser } = useSelector((state: any) => state.userReducer);
    //const currentUser = JSON.parse(localStorage.getItem('currentUser') || '')
    const { accountUsersList, addUserStatus } = useSelector((state: any) => state.accountUsersReducer);
    const [activeStep, setActiveStep] = React.useState(0);
    const [snackOpen, setSnackOpen] = React.useState(false);
    const [availableGroups, setAvailableGroups] = React.useState<number[]>([]);
    const [firstName, setFirstName] = React.useState<string>('');
    const [lastName, setLastName] = React.useState<string>('');
    const [login, setLogin] = React.useState<string>('');
    const [password, setPassword] = React.useState<string>('');
    const [repeatPassword, setRepeatPassword] = React.useState<string>('');
    const [userType, setUserType] = React.useState<string>('');
    const [notification, setNotification] = React.useState<boolean>(false);
    const [message, setMessage] = React.useState<string>('');
    const [status, setStatus] = React.useState(false);
    const { t } = useTranslation();
    const [passwordError, setPasswordError] = useState<string>('');

    const isValidEmail = (email:string) => {
        const isValid = /\S+@\S+\.\S+/.test(email);
        return isValid
      }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const steps = [
        {
            component: (
                <AddUserForm
                    firstName={firstName}
                    setFirstName={setFirstName}
                    lastName={lastName}
                    setLastName={setLastName}
                    login={login}
                    setLogin={setLogin}
                    password={password}
                    setPassword={setPassword}
                    repeatPassword={repeatPassword}
                    setRepeatPassword={setRepeatPassword}
                    userType={userType}
                    setUserType={setUserType}
                    notification={notification}
                    setNotification={setNotification}
                    setPasswordError={setPasswordError}
                />
            ),
        },
        { component: <AddUserGroups setAvailableGroups={setAvailableGroups} /> },
    ];

    React.useEffect(() => {
        if (status === true) {
            if (addUserStatus === 200) {
                setCount(count + 1);
                setMessage(`${t('msg_usr_added')}`);
            } else if (addUserStatus === 500) {
                setMessage(`${t('msg_internal_error')}`);
            } else if (addUserStatus === 400) {
                setMessage(`${t('lbl_unauthorizedUser')}`);
            } else {
                setMessage(`${t('lbl_someError')}`);
            }
            setSnackOpen(true);
            setStatus(false);
        }
    }, [status]);

    const handleClose = () => {
        setFirstName('');
        setLastName('');
        setLogin('');
        setUserType('');
        setPassword('');
        setRepeatPassword('')
        setNotification(false);
        setOpen(false);
        setActiveStep(0);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSave = async () => {
        if (accountUsersList.some((item: AccountUsersProps) => item.login === login)) {
            setMessage(`${t('msg_usrExist')}`);
        } else {
            const body = {
                firstName: firstName,
                groupId: currentUser.groupId,
                lastName: lastName,
                login: login,
                password: password,
                repeatPassword: repeatPassword,
                userType: userType,
            };
            await dispatch(addUser(body, availableGroups, notification, currentUser.ID));
            setStatus(true);
        }
        setFirstName('');
        setLastName('')
        setLogin('')
        setPassword('')
        setRepeatPassword('')
        setUserType('');
        setNotification(false)
        setActiveStep(0);
        setOpen(false);
    };

    const handleSnackClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackOpen(false);
    };

    const action = (
        <React.Fragment>
            <Button color="primary" size="small" onClick={handleSnackClose}>
            {t('lbl_close')}
            </Button>
        </React.Fragment>
    );

    return (
        <div>
            {md ? (
                <>
                    <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box
                            sx={{
                                position: 'absolute' as 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'background.paper',
                                boxShadow: 20,
                                p: 0,
                            }}
                        >
                            <Paper elevation={0} sx={{ pb: 0 }}>
                                <Paper
                                    elevation={4}
                                    sx={{
                                        paddingTop: 2,
                                        paddingBottom: 1,
                                        paddingLeft: 2,
                                        paddingRight: 2,
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <IconButton onClick={handleClose}>
                                        <ArrowBackIcon />
                                    </IconButton>
                                    &ensp;&ensp;
                                    <Typography sx={{ pt: 0.5 }} variant="h6">
                                    {t('btn_addUsr')}
                                    </Typography>
                                </Paper>
                                <Divider />
                                {steps[activeStep].component}
                            </Paper>
                            <Divider />
                            <Paper sx={{
                                    position: 'absolute' as 'absolute',
                                    top: '95vh',
                                    zIndex: 1000,
                                    transform: 'translateY(-100%)',
                                    width: '100%',
                                }}>
                                <MobileStepper
                                    variant="dots"
                                    steps={2}
                                    position="static"
                                    activeStep={activeStep}
                                    sx={{
                                        maxWidth: '100%',
                                        flexGrow: 1,
                                        paddingTop: 2,
                                        paddingBottom: 4,
                                        paddingLeft: 3,
                                        paddingRight: 3,
                                        backgroundColor: 'inherit',
                                    }}
                                    nextButton={
                                        activeStep < 1 ? (
                                            <Button
                                                size="medium"
                                                variant="contained"
                                                disabled={
                                                    firstName === '' ||
                                                    lastName === '' ||
                                                    login === '' ||
                                                    password === '' ||
                                                    repeatPassword === '' ||
                                                    userType === '' ||
                                                    password !== repeatPassword ||
                                                    firstName.length > 24 ||
                                                    lastName.length > 24 ||
                                                    login.length>48||
                                                    passwordError.length>0 ||
                                                    (!isValidEmail(login))
                                                }
                                                onClick={handleNext}
                                            >
                                               {t('btn_next')}
                                            </Button>
                                        ) : (
                                            <Button size="medium" variant="contained" onClick={handleSave}>
                                                {t('btn_save')}
                                            </Button>
                                        )
                                    }
                                    backButton={
                                        activeStep < 1 ? (
                                            <Button size="small" variant="outlined" onClick={handleClose}>
                                                {t('btn_cancel')}
                                            </Button>
                                        ) : (
                                            <Button size="small" variant="outlined" onClick={handleBack}>
                                                {t('btn_back')}
                                            </Button>
                                        )
                                    }
                                />
                            </Paper>
                        </Box>
                    </Modal>
                    <Snackbar
                        open={snackOpen}
                        autoHideDuration={6000}
                        onClose={handleSnackClose}
                        message={message}
                        action={action}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    />
                </>
            ) : (
                <>
                    <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box sx={style}>
                            <Paper
                                elevation={0}
                                sx={{ paddingTop: 2, paddingBottom: 3, paddingLeft: 3, paddingRight: 2 }}
                            >
                                <Typography variant="h6">{t('btn_addUsr')}</Typography>
                            </Paper>
                            <Divider />
                            <Paper elevation={0} sx={{}}>
                                {steps[activeStep].component}
                            </Paper>
                            <Divider />
                            <MobileStepper
                                variant="dots"
                                steps={2}
                                position="static"
                                activeStep={activeStep}
                                sx={{
                                    maxWidth: 500,
                                    flexGrow: 1,
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                    paddingLeft: 3,
                                    paddingRight: 3,
                                    backgroundColor: 'inherit',
                                }}
                                nextButton={
                                    activeStep < 1 ? (
                                        <Button
                                            size="medium"
                                            variant="contained"
                                            disabled={
                                                firstName === '' ||
                                                lastName === '' ||
                                                login === '' ||
                                                password === '' ||
                                                repeatPassword === '' ||
                                                userType === '' ||
                                                password !== repeatPassword || 
                                                firstName.length > 24 ||
                                                lastName.length > 24 ||
                                                login.length>48||
                                                passwordError.length > 0 ||
                                                (!isValidEmail(login))
                                            }
                                            onClick={handleNext}
                                        >
                                            {t('btn_next')}
                                        </Button>
                                    ) : (
                                        <Button size="medium" variant="contained" onClick={handleSave}>
                                            {t('btn_save')}
                                        </Button>
                                    )
                                }
                                backButton={
                                    activeStep < 1 ? (
                                        <Button size="small" variant="outlined" onClick={handleClose}>
                                            {t('btn_cancel')}
                                        </Button>
                                    ) : (
                                        <Button size="small" variant="outlined" onClick={handleBack}>
                                             {t('btn_back')}
                                        </Button>
                                    )
                                }
                            />
                        </Box>
                    </Modal>
                    <Snackbar
                        open={snackOpen}
                        autoHideDuration={6000}
                        onClose={handleSnackClose}
                        message={message}
                        action={action}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    />
                </>
            )}
        </div>
    );
}
